export function twink(on, off) {
    on();
    setTimeout(() => {
        off();
        setTimeout(() => {
            on();
            setTimeout(() => {
                off();
            }, 200);
        }, 100);
    }, 200);
}
